<template>
    <div class="index">

        <div class="loader-wrapper" v-if="loading">
            <div class="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>

        <div class="container">

            <form class="inputform" @submit.prevent="doSearch()">
                <div class="inner">
                    <input type="text" v-model="licenseplate" placeholder="Indtast nummerplade..." />    
                    <button type="submit">Søg</button>
                </div>
            </form>

            <!--<div v-if="!loading && vehicleData">
                <hr>
                <h3>
                    {{ vehicleData.general.MaerkeTypeNavn }}
                    {{ vehicleData.general.ModelTypeNavn }}
                    {{ vehicleData.general.VariantTypeNavn }}
                </h3>
                {{ vehicleData.general.ModelAar }}
                <hr>
                Vehicle data:
                <br><br>
                {{ vehicleData }}
            </div>-->

            <div class="vehicle-header animated fadeInUp" v-if="!loading && vehicleData">
                <!--<i class="fas fa-motorcycle fa-fw" v-if="vehicleData.general.KoeretoejArtNavn === 'Motorcykel'" />
                <i class="fas fa-car fa-fw" v-else />
                <br>
                {{ vehicleData.general.MaerkeTypeNavn }}
                {{ vehicleData.general.ModelTypeNavn }}
                {{ vehicleData.general.VariantTypeNavn }}-->
                <div class="logo">
                    <!--<img src="https://www.stickpng.com/assets/images/580b585b2edbce24c47b2cac.png" />-->
                    <i class="fal fa-car fa-fw" />
                </div>
                <div class="text">
                    <div class="make-model">
                        {{ vehicleData.general.MaerkeTypeNavn }}
                        {{ vehicleData.general.ModelTypeNavn }}
                    </div>
                    <div class="variant">
                        {{ vehicleData.general.VariantTypeNavn }}
                    </div>
                </div>
            </div>

            <div class="grid-layout animated fadeIn delay-1s" v-if="!loading && vehicleData">
                <div class="main-area">
                    <div class="block">
                        <div class="title">
                            Generelt
                        </div>
                        <div class="body">
                            <!--{{ vehicleData.general }}-->
                            <div class="line">
                                <div class="line__title">Model årgang</div>
                                <div class="line__value">
                                    <span v-if="vehicleData.general.ModelAar">{{ vehicleData.general.ModelAar }}</span>
                                    <span v-else>-</span>
                                </div>
                            </div>
                            <div class="line">
                                <div class="line__title">Indregistreret</div>
                                <div class="line__value">
                                    <span v-if="vehicleData.general.FoersteRegistreringDato">{{ vehicleData.general.FoersteRegistreringDato | moment('D[.] MMMM YYYY') }}</span>
                                    <span v-else>-</span>
                                </div>
                            </div>
                            <div class="line">
                                <div class="line__title">Art</div>
                                <div class="line__value">
                                    <span v-if="vehicleData.general.KoeretoejArtNavn">{{ vehicleData.general.KoeretoejArtNavn }}</span>
                                    <span v-else>-</span>
                                </div>
                            </div>
                            <div class="line">
                                <div class="line__title">Stelnummer</div>
                                <div class="line__value">
                                    <span v-if="vehicleData.general.StelNr">{{ vehicleData.general.StelNr }}</span>
                                    <span v-else>-</span>
                                </div>
                            </div>
                            <div class="line">
                                <div class="line__title">Forsikring</div>
                                <div class="line__value">
                                    <a href="https://www.partner-ads.com/dk/klikbanner.php?partnerid=28784&bannerid=60068&htmlurl=https://www.findforsikring.dk/indhent-tilbud-mini/?bil1=on">Se forsikringspriser her</a>
                                </div>
                            </div>
                            <div class="line">
                                <div class="line__title">Finansiering</div>
                                <div class="line__value">
                                    <a href="javascript:void(0)">Se oversigt over lånemuligheder</a>
                                </div>
                            </div>
                            <div class="line">
                                <div class="line__title">Status</div>
                                <div class="line__value">
                                    <span v-if="vehicleData.general.Status">{{ vehicleData.general.Status }}</span>
                                    <span v-else>-</span>
                                </div>
                            </div>
                            <div class="line">
                                <div class="line__title">Nuværende ejer</div>
                                <div class="line__value">
                                    <span v-if="vehicleData.general.currentOwner">{{ vehicleData.general.currentOwner }}</span>
                                    <span v-else>-</span>
                                </div>
                            </div>
                            <div class="line">
                                <div class="line__title">Motor</div>
                                <div class="line__value">
                                    <span v-if="vehicleData.general.MotorStoerrelse">
                                        {{ vehicleData.general.MotorStoerrelse }}
                                        ({{ vehicleData.general.MotorSlagVolumen }} ccm,
                                        {{ vehicleData.general.MotorCylinderAntal }} cyl.,
                                        {{ vehicleData.general.DrivkraftTypeNavn }})
                                    </span>
                                    <span v-else>-</span>
                                </div>
                            </div>
                            <div class="line">
                                <div class="line__title">Effekt</div>
                                <div class="line__value">
                                    <span v-if="vehicleData.general.MotorHestekraefter">
                                        {{ vehicleData.general.MotorHestekraefter }} HK
                                        ({{ vehicleData.general.MotorStoersteEffekt }} kW)
                                    </span>
                                    <span v-else>-</span>
                                </div>
                            </div>
                            <div class="line">
                                <div class="line__title">Opgivet forbrug</div>
                                <div class="line__value">
                                    <span v-if="vehicleData.general.MotorKmPerLiter">{{ vehicleData.general.MotorKmPerLiter }} km/l</span>
                                    <span v-else>-</span>
                                </div>
                            </div>
                            <div class="line">
                                <div class="line__title">Fælge / dæk</div>
                                <div class="line__value">
                                    <span v-if="vehicleData.general.FaelgDaek">{{ vehicleData.general.FaelgDaek }}</span>
                                    <span v-else>-</span>
                                </div>
                            </div>
                            <div class="line">
                                <div class="line__title">Sidst synet</div>
                                <div class="line__value">
                                    <span v-if="vehicleData.dmr.SidsteSyn">
                                        {{ vehicleData.dmr.SidsteSyn | moment('D[.] MMMM YYYY') }}
                                    </span>
                                    <span v-else>
                                        Køretøjet har ikke været synet endnu
                                    </span>
                                </div>
                            </div>
                            <div class="line">
                                <div class="line__title">Næste syn</div>
                                <div class="line__value">
                                    <span v-if="vehicleData.dmr.NaesteSyn">{{ vehicleData.dmr.NaesteSyn | moment('D[.] MMMM YYYY') }}</span>
                                    <span v-else>-</span>
                                </div>
                            </div>
                            <div class="line">
                                <div class="line__title">Afgift</div>
                                <div class="line__value">
                                    <span v-if="vehicleData.dmr.Afgift.AfgiftDetaljer.length > 0">
                                        <span v-for="afgift in vehicleData.dmr.Afgift.AfgiftDetaljer" v-if="afgift.AfgiftType === 'Sum'" v-bind:key="afgift.AfgiftType">
                                            {{ afgift.Pris }} / halvårlig
                                        </span>
                                    </span>
                                    <span v-else>-</span>
                                </div>
                            </div>
                            <div class="line">
                                <div class="line__title">Udstyr</div>
                                <div class="line__value">
                                    <span v-if="vehicleData.general.KoeretoejUdstyrSamling.length > 0">
                                        <div class="single-feature" v-for="feature in vehicleData.general.KoeretoejUdstyrSamling" v-bind:key="feature">
                                            {{ feature }}
                                        </div>
                                    </span>
                                    <span v-else>-</span>
                                </div>
                            </div>
                            <div class="line line__fw" v-if="vehicleData.stats.SimilarCarsCount && vehicleData.general.ModelAar && vehicleData.general.ModelAar !== '-'">
                                Der er <span style="font-weight:bold;">&nbsp;{{ vehicleData.stats.SimilarCarsCount }}&nbsp;</span> {{ vehicleData.general.MaerkeTypeNavn }} {{ vehicleData.general.ModelTypeNavn }}<span v-if="vehicleData.general.ModelAar && vehicleData.general.ModelAar !== '-'">, årgang {{ vehicleData.general.ModelAar }}&nbsp;</span>indregistreret i DK
                            </div>
                        </div>
                    </div>
                    <div class="block">
                        <div class="title">
                            Gæld / Bilbogen
                        </div>
                        <div class="body">
                            <div v-if="vehicleData.registry.LaaneDokumenter.length === 0">
                                Der er ikke registreret gæld i køretøjet
                            </div>
                            <div v-if="vehicleData.registry && vehicleData.registry.LaaneDokumenter.length > 0">
                                <div class="line">
                                    <div class="line__title">Hvem skylder</div>
                                    <div class="line__value">
                                        {{ vehicleData.registry.LaaneDokumenter[0].Debitorer[0].Navn }}
                                        <br>
                                        CPR: {{ vehicleData.registry.LaaneDokumenter[0].Debitorer[0].FoedselsDato }} (XX år)
                                    </div>
                                </div>
                                <div class="line">
                                    <div class="line__title">Stelnummer</div>
                                    <div class="line__value">
                                        {{ vehicleData.general.StelNr }}
                                    </div>
                                </div>
                                <div class="line">
                                    <div class="line__title">Oprindelige lån</div>
                                    <div class="line__value">
                                        {{ vehicleData.registry.LaaneDokumenter[0].HovedStol }}
                                    </div>
                                </div>
                                <div class="line">
                                    <div class="line__title">Kreditor</div>
                                    <div class="line__value">
                                        {{ vehicleData.registry.LaaneDokumenter[0].Underpanthaver }}
                                    </div>
                                </div>
                                <div class="line" v-if="vehicleData.registry.LaaneDokumenter[0].Underpanthaver">
                                    <div class="line__title">Bemærkninger</div>
                                    <div class="line__value">
                                        <div v-for="attention in vehicleData.registry.LaaneDokumenter[0].TillaegsTekster">
                                            {{ attention }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="block">
                        <div class="title">
                            Økonomi / beregner
                        </div>
                        <div class="body">
                            Antagelser: 11 kr. per liter benzin
                            <br><br>
                            <div class="line line__df">
                                <div class="line__title">Antal km om året</div>
                                <div class="line__val">
                                    <input type="number" class="form-control" v-model="calculator.kmPerYear" min="0" max="150000" />
                                </div>
                            </div>
                            <div class="line line__df">
                                <div class="line__title">Service / reparation pr. 100 km</div>
                                <div class="line__val">
                                    <input type="number" class="form-control" v-model="calculator.expensePerHundredKm" min="0" max="100" />
                                </div>
                            </div>
                            <div class="line line__df">
                                <div class="line__title">Evt. afbetaling pr. måned</div>
                                <div class="line__val">
                                    <input type="number" class="form-control" v-model="calculator.payoff" min="0" max="100000" />
                                </div>
                            </div>
                            <div class="line line__df">
                                <div class="line__title">Forsikring pr. år</div>
                                <div class="line__val">
                                    <input type="number" class="form-control" v-model="calculator.insurance" min="0" max="100000" />
                                </div>
                            </div>
                            <hr>
                            <div class="line line__df">
                                <div class="line__title">Brændstof</div>
                                <div class="line__value">667 kr.</div>
                            </div>
                            <div class="line line__df">
                                <div class="line__title">Service / reparation</div>
                                <div class="line__value">379 kr.</div>
                            </div>
                            <div class="line line__df">
                                <div class="line__title">Afbetaling</div>
                                <div class="line__value">{{ calculator.payoff }} kr.</div>
                            </div>
                            <div class="line line__df">
                                <div class="line__title">Forsikring</div>
                                <div class="line__value">{{ calculator.insurance }} kr.</div>
                            </div>-->
                            <hr>
                            <div class="line line__df">
                                <div class="line__title" style="font-size:20px;">Månedlig udgift</div>
                                <div class="line__value" style="font-size:20px;"><b>{{ monthlyExpense }} kr.</b></div>
                            </div>
                            <hr>
                            <i>Beregneren tager ikke højde for afdrag på lån, service, reparationer og forsikring.</i>
                        </div>
                    </div>
                    <div class="block">
                        <div class="title">
                            Synsrapporter
                        </div>
                        <div class="body">
                            <div class="line" v-for="report in vehicleData.inspection.Rapporter" v-if="vehicleData && vehicleData.inspection.Rapporter">
                                <div class="line__title">{{ report.Synsdato }}</div>
                                <div class="line__value">
                                    <!--<div class="good" v-if="report.Synsresultat === 'Godkendt'">
                                        <i class="fas fa-check fa-fw" />
                                        Godkendt
                                    </div>
                                    <div class="bad" v-else>
                                        <i class="fas fa-exclamation fa-fw" />
                                        Ikke godkendt
                                        <span class="extra">
                                            <i class="fas fa-exclamation fa-fw" />
                                            {{ report.Synsresultat }}
                                        </span>
                                    </div>-->
                                    {{ report.Synsresultat }}
                                    <br>
                                    <a href="javascript:void(0)">
                                        Vis synsrapport
                                    </a>
                                    <div class="inspection-report" v-if="showInspectionReportModal && inspectionReport !== null">
                                        <div class="inner">
                                            <div class="header">
                                                <div class="result">
                                                    {{ inspectionReport.Synsresultat }}
                                                </div>
                                                <div class="company">
                                                    <b>{{ inspectionReport.Firma }}</b>
                                                    <br>
                                                    {{ inspectionReport.Adresse }}
                                                    <br>
                                                    CVR: {{ inspectionReport.Cvr }}        
                                                </div>
                                            </div>
                                            <div class="boxes">
                                                <div class="box">
                                                    <div class="box__title">
                                                        Synsdato
                                                    </div>
                                                    <div class="box__value">
                                                        {{ inspectionReport.Synsdato | moment('D[.] MMMM YYYY') }}
                                                    </div>
                                                </div>
                                                <div class="box">
                                                    <div class="box__title">
                                                        Synstype
                                                    </div>
                                                    <div class="box__value">
                                                        {{ inspectionReport.Synstype }}
                                                    </div>
                                                </div>
                                                <div class="box">
                                                    <div class="box__title">
                                                        Nummerplade
                                                    </div>
                                                    <div class="box__value">
                                                        {{ inspectionReport.RegNr }}
                                                    </div>
                                                </div>
                                                <div class="box">
                                                    <div class="box__title">
                                                        Kilometerstand
                                                    </div>
                                                    <div class="box__value">
                                                        203.000 km
                                                    </div>
                                                </div>
                                            </div>
                                            <hr>
                                            <h3>Fejl</h3>
                                            <div class="error-wrapper" v-if="inspectionReport.Fejl.length > 0">
                                                <div class="error" v-for="error in inspectionReport.Fejl">
                                                    <b>{{ error.Number }}</b>
                                                    {{ error.Description }}
                                                </div>
                                            </div>
                                            <div v-else>
                                                Ingen fejl registreret.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!--{{ report.Synsdato }}:
                                <br>
                                {{ report.Synsresultat }}
                                <div class="errors" v-if="report.Fejl.length > 0">
                                    <br>
                                    Fejl:
                                    <ul>
                                        <li class="error" v-for="error in report.Fejl" v-bind:key="error.Number">
                                            {{ error.Title }}:
                                            {{ error.Description }}
                                        </li>
                                    </ul>
                                </div>
                                <hr>-->
                            </div>
                            <div v-if="vehicleData.inspection.Rapporter.length === 0">
                                Køretøjet har ikke været synet endnu
                            </div>
                        </div>
                    </div>
                    <div class="block">
                        <div class="title">
                            Afgifter
                        </div>
                        <div class="body">
                            <div class="table" v-if="vehicleData.dmr.Afgift.OpkraevedeAfgifter.length > 0">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Reg.nr.</th>
                                            <th>Type</th>
                                            <th>Dækker fra/til</th>
                                            <th>Beløb</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="afgift in vehicleData.dmr.Afgift.OpkraevedeAfgifter">
                                            <td>{{ afgift.RegNr }}</td>
                                            <td>{{ afgift.AfgiftType }}</td>
                                            <td>{{ afgift.DaekkerFra }} - {{ afgift.DaekkerTil }}</td>
                                            <td>{{ afgift.Pris }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <!--<div class="block">
                        <div class="title">
                            Affiliate links
                        </div>
                        <div class="body">
                            <ul>
                                <li>Lignende biler til salg (bilhandel.dk)</li>
                                <li>Nyeste indlæg ang. denne bilmodel på bilgalleri.dk</li>
                                <li>Forsikringstilbud</li>
                                <li>Anmeldelser på YouTube</li>
                                <li>Lån penge til denne bil (beregner måske)</li>
                            </ul>
                        </div>
                    </div>
                    <div class="block">
                        <div class="title">
                            Materiale
                        </div>
                        <div class="body">
                            <ul>
                                <li>Forhåndsudfyldt slutseddel</li>
                                <li>Sæt bil til salg</li>
                                <li>Attest til salgsannonce</li>
                            </ul>
                        </div>
                    </div>-->
                    <!--<img src="/static/autobutler2.png" style="width:100%;border-radius:5px;box-shadow:0px 5px 15px rgba(0,0,0,0.15);border:1px solid rgba(0,0,0,0.15);cursor:pointer;" />-->
                    <!--<div class="banner-wrapper">
                        <div class="single-banner">
                            <img src="/static/autobutler2.png" />
                        </div>
                    </div>-->
                </div>
                <div class="sidebar-area">
                    <img v-if="vehicleData && vehicleData.general.RegNr === 'AL52114'" src="https://www.nummerplade.net/apps/nummerplade/carimage/8848406975.jpg" style="width:100%;margin-bottom:30px;border-radius:5px;box-shadow:0px 5px 15px rgba(0,0,0,0.15);" />
                    <img v-if="vehicleData && vehicleData.general.RegNr === 'BP59902'" src="/static/xsr700.jpeg" style="width:100%;margin-bottom:30px;border-radius:5px;box-shadow:0px 5px 15px rgba(0,0,0,0.15);" />
                    <img v-if="vehicleData && vehicleData.general.RegNr !== 'AL52114' && vehicleData.general.RegNr !== 'BP59902'" :src="'https://placehold.it/1200x799?text=' + vehicleData.general.MaerkeTypeNavn + ' ' + vehicleData.general.ModelTypeNavn + ' ' + vehicleData.general.VariantTypeNavn" style="width:100%;margin-bottom:30px;border-radius:5px;box-shadow:0px 5px 15px rgba(0,0,0,0.15);" />
                    <div class="block">
                        <div class="title">
                            Hurtigt tjek
                        </div>
                        <div class="body">
                            <div class="single-check">
                                <div class="inner good">
                                    <i class="fas fa-check fa-fw" />
                                    Køretøjet er ikke efterlyst
                                </div>
                            </div>
                            <div class="single-check">
                                <div class="inner bad" v-if="vehicleData.registry.LaaneDokumenter.length > 0">
                                    <i class="fas fa-exclamation fa-fw" />
                                    Der er registreret pant i køretøjet!
                                </div>
                                <div class="inner neutral" v-if="vehicleData.general.LeasingPeriode">
                                    <i class="fas fa-info fa-fw" />
                                    Køretøjet er leaset
                                </div>
                                <div class="inner good" v-if="vehicleData.registry.LaaneDokumenter.length === 0 && !vehicleData.general.LeasingPeriode">
                                    <i class="fas fa-check fa-fw" />
                                    Der er ikke registreret pant i køretøjet
                                </div>
                            </div>
                            <div class="single-check">
                                <div class="inner good" v-if="vehicleData.inspection.Rapporter.length > 0 && vehicleData.inspection.Rapporter[0].Synsresultat === 'Godkendt'">
                                    <i class="fas fa-check fa-fw" />
                                    Køretøjet bestod seneste syn
                                    <!--<span class="extra" v-if="vehicleData.dmr.NaesteSyn">
                                        <i class="fas fa-check fa-fw" />
                                        Næste syn: {{ vehicleData.dmr.NaesteSyn | moment('D[.] MMMM YYYY') }}
                                    </span>-->
                                </div>
                                <div class="inner bad" v-if="vehicleData.inspection.Rapporter.length > 0 && vehicleData.inspection.Rapporter[0].Synsresultat !== 'Godkendt'">
                                    <i class="fas fa-exclamation fa-fw" />
                                    Køretøjet bestod ikke seneste syn
                                </div>
                                <div class="inner good" v-if="vehicleData.inspection.Rapporter.length === 0">
                                    <i class="fas fa-check fa-fw" />
                                    Køretøjet har ikke været synet endnu
                                </div>
                            </div>
                            <div class="single-check">
                                <div class="inner good">
                                    <i class="fas fa-check fa-fw" />
                                    Ingen tegn på kilometerfusk
                                </div>
                            </div>
                            <div class="single-check">
                                <div class="inner good" v-if="vehicleData.dmr.Forsikring.Status === 'Aktiv'">
                                    <i class="fas fa-check fa-fw" />
                                    Køretøjet er forsikret
                                </div>
                                <div class="inner bad" v-else>
                                    <i class="fas fa-exclamation fa-fw" />
                                    Køretøjet er ikke forsikret
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="block">
                        <div class="title">
                            Forsikring
                        </div>
                        <div class="body">
                            <div class="line">
                                <div class="line__title">Status</div>
                                <div class="line__value">{{ vehicleData.dmr.Forsikring.Status }}</div>
                            </div>
                            <div class="line">
                                <div class="line__title">Selskab</div>
                                <div class="line__value">{{ vehicleData.dmr.Forsikring.Selskab }}</div>
                            </div>
                            <div class="line">
                                <div class="line__title">Oprettet</div>
                                <div class="line__value">{{ vehicleData.dmr.Forsikring.Oprettet | moment('D[.] MMMM YYYY') }}</div>
                            </div>
                        </div>
                    </div>
                    <!--<div class="block">
                        <div class="title">
                            Stats
                        </div>
                        <div class="body">
                            {{ vehicleData.stats }}
                        </div>
                    </div>
                    <div class="block">
                        <div class="title">
                            Biler med flest HK
                        </div>
                        <div class="body">
                            Liste
                        </div>
                    </div>-->
                    <!--<div class="banner-wrapper">
                        <div class="single-banner">
                            <img src="/static/autobutler.png" />
                        </div>
                    </div>-->
                </div>
            </div>

            <!--<div v-if="!loading && vehicleData">SAMMENLIGN BILER</div>-->

            <!--<div class="grid-layout">
                <div class="block">
                    <div class="title">
                        Oversigt over alle data
                    </div>
                    <div class="body">
                        <div class="line" v-for="(item, key) in vehicleData.general" v-if="item !== null">
                            <div class="line__title">{{ key }}</div>
                            <div class="line__value">{{ item }}</div>
                        </div>
                        <div class="line" v-for="(item, key) in vehicleData.dmr" v-if="item !== null">
                            <div class="line__title">{{ key }}</div>
                            <div class="line__value">{{ item }}</div>
                        </div>
                        <div class="line" v-for="(item, key) in vehicleData.registry" v-if="item !== null">
                            <div class="line__title">{{ key }}</div>
                            <div class="line__value">{{ item }}</div>
                        </div>
                    </div>
                </div>
            </div>-->

        </div>

    </div>
</template>

<style lang="scss" scoped>
@import "../../styles/vars";

    .index {
        /* background: #283C86;
        // background: linear-gradient(45deg, rgba(40, 60, 134, 0.5), rgba(40, 60, 134, 0.5)), url('https://tracking.postnord.com/assets/images/background-large.jpg') center center no-repeat;
        background: url('/static/bg.png') center center no-repeat;
        background-size: cover;
        background-attachment: fixed; */
        background: $color--main--gradient;
        min-height: 100vh;
        z-index: 98;

        .alldata {
            background: #fff;
            margin: 50px 0 100px 0;
            padding: 30px;

            .title {
                font-size: 20px;
                text-decoration: underline;
                margin-bottom: 15px;
            }

            .lines {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;

                .line {
                    flex: 0 0 30%;
                    display: flex;
                    justify-content: space-between;
                    padding: 5px 0;
                    border-top: 1px solid rgba(0, 0, 0, 0.1);
                    align-items: center;

                    .key {
                        word-break: break-all;
                    }

                    .value {
                        padding-left: 30px;
                        text-align: right;
                    }
                }
            }
        }

        .inputform {
            display: flex;
            justify-content: center;
            padding: 50px 0;

            input {
                min-width: 30vw;
                height: 50px;
                box-sizing: border-box;
                font-size: 24px;
                padding: 0 30px;
                border-radius: 100px;
                border: none;
                outline: none;
                margin-right: 30px;
                text-transform: uppercase;
                box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);
            }

            button {
                height: 50px;
                font-size: 24px;
                padding: 0 30px;
                border-radius: 100px;
                border: none;
                outline: none;
                background: #fff;
                box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);
            }
        }

        .loader-wrapper {
            font-size: 50px;
            color: #fff;
            text-align: center;
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            z-index: 99;
            background: rgba(0, 0, 0, 0.25);
            height: 100px;
            width: 100px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 25px;
        }

        .vehicle-header {
            font-size: 30px;
            margin-bottom: 30px;
            background: #fff;
            padding: 30px;
            display: flex;
            align-items: center;

            .logo {
                padding-right: 50px;
                font-size: 50px;

                img {
                    width: 100px;
                }
            }

            .text {
                font-weight: 600;
                
                .variant {
                    font-size: 20px;
                    font-weight: 400;
                }
            }
        }

        .grid-layout {
            display: flex;
            flex-wrap: wrap;

            .main-area {
                flex: 0 0 70%;
                padding-right: 30px;
            }

            .sidebar-area {
                flex: 0 0 30%;
            }

            .block {
                background: #fff;
                box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);
                border-radius: 2px;
                padding: 30px;
                margin-bottom: 30px;
                box-sizing: border-box;
                width: 100%;

                .title {
                    font-size: 24px;
                    margin-bottom: 15px;
                    font-weight: bold;
                }

                .body {
                    overflow-y: auto;
                    -webkit-overflow-scrolling: touch;
                    overflow-x: hidden;
                    // max-height: 200px;

                    .good {
                        color: $color--green;
                    }

                    .bad {
                        color: $color--red;
                    }

                    .neutral {
                        color: $color--orange;
                    }

                    .extra {
                        display: block;
                        color: #333;

                        i {
                            opacity: 0;
                        }
                    }

                    .line {
                        display: flex;

                        &__fw {
                            display: block;
                        }

                        &__df {
                            align-items: center;
                        }

                        &:not(:last-of-type) {
                            margin-bottom: 15px;
                        }

                        &__title {
                            flex: 0 0 25%;
                            font-weight: 400;
                            word-break: break-word;
                        }

                        &__value {
                            flex: 0 0 75%;
                            font-weight: 600;
                            padding-left: 15px;

                            a {
                                color: $color--main;
                            }

                            .single-feature {
                                display: inline-block;
                                margin: 0 5px 5px 0;
                                padding: 2px 5px;
                                border: 1px solid rgba(0, 0, 0, 0.15);
                                font-size: 12px;
                            }
                        }
                    }

                    .table {
                        margin: 0;
                        overflow-x: auto;

                        table {
                            width: 100%;
                            min-width: 400px;

                            td {
                                padding-top: 10px;
                                padding-right: 20px;
                            }
                        }
                    }

                    .single-check {

                        &:not(:last-of-type) .inner {
                            margin-bottom: 10px;
                        }

                        .inner {

                            .extra {
                                display: block;
                                color: #333;

                                i {
                                    opacity: 0;
                                }
                            }

                            &.good {
                                color: $color--green;
                            }

                            &.bad {
                                color: $color--red;
                            }

                            &.neutral {
                                color: $color--orange;
                            }
                        }
                    }

                    .inspection-report {
                        position: fixed;
                        top: 0;
                        right: 0;
                        bottom: 0;
                        left: 0;
                        background: rgba(0, 0, 0, 0.15);

                        .inner {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%,-50%);
                            width: 800px;
                            max-width: 90vw;
                            max-height: 70vh;
                            padding: 30px;
                            background: #fff;
                            border-radius: 5px;
                            font-weight: 400;
                            overflow-y: auto;

                            .header {
                                display: flex;
                                justify-content: space-between;
                                align-items: center;

                                .result {
                                    font-size: 24px;
                                }

                                .company {
                                    
                                    white-space: nowrap;
                                }
                            }

                            .boxes {
                                display: flex;
                                justify-content: flex-start;
                                margin: 50px 0;

                                .box {
                                    flex: 0 0 25%;
                                    text-align: center;

                                    &__title {
                                        font-weight: 400;
                                    }

                                    &__value {
                                        font-weight: 600;
                                    }
                                }
                            }

                            .error-wrapper {
                                display: flex;
                                flex-wrap: wrap;
                                justify-content: space-between;

                                .error {
                                    flex: 0 0 100%;

                                    &:not(:last-of-type) {
                                        margin-bottom: 15px;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .banner-wrapper {
                background: #fff;
                width: 100%;
                margin-bottom: 30px;
                overflow: hidden;
                border-radius: 5px;
                box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);
                cursor: pointer;
                transition: .3s ease all;

                &:hover {
                    transform: scale(1.025);
                }

                .single-banner {
                    background: red;
                    width: 100%;

                    img {
                        width: 100%;
                        margin-top: -1px;
                        margin-left: -1px;
                        width: calc(100% + 2px);
                        margin-bottom: -1px;
                    }
                }
            }
        }
    }

    @media screen and (max-width: 768px) {
        .inputform {
            padding: 25px 0 !important;

            input {
                margin: 0 15px 0 0 !important;
                width: 50vw;
            }
        }

        .grid-layout {
            flex-direction: column-reverse !important;
        }

        .main-area {
            flex: 0 0 100% !important;
            width: 100%;
            padding-right: 0px !important;
        }

        .sidebar-area {
            flex: 0 0 100% !important;
            width: 100%;
        }

        .alldata {
            display: none !important;
        }

        .block .body .line {
            display: block !important;

            &__value {
                padding: 0 !important;
            }
        }
    }

</style>

<script>
import * as lookupService from '@/services/lookup/lookupService'
import axios from 'axios'

export default {
    data () {
        return {
            licenseplate: '',
            vehicleData: null,
            loading: false,
            inspectionReport: null,
            showInspectionReportModal: false,
            calculator: {
                kmPerYear: 15500,
                expensePerHundredKm: 30,
                payoff: 0,
                insurance: 4500
            }
        }
    },
    created () {
        this.checkForQuery()
    },
    methods: {
        doSearch () {
            this.vehicleData = null
            this.loading = true
            lookupService.find(this.licenseplate, {}, (response) => {
                this.vehicleData = Object.assign({}, response.data[0])
                this.loading = false
                let carString = this.licenseplate.toUpperCase() + ' | ' + this.vehicleData.general.MaerkeTypeNavn + ' ' + this.vehicleData.general.ModelTypeNavn + ' ' + this.vehicleData.general.VariantTypeNavn
                if (process.env.NODE_ENV === 'production') {
                    if ('ga' in window) {
                        let tracker = window.ga.getAll()[0]
                        if (tracker) {
                            tracker.send('event', 'Søgeresultat', 'Nummerplade', carString)
                            if (this.vehicleData.dmr.Forsikring.Selskab === 'SELVFORSIKRING') {
                                tracker.send('event', 'Civile politibiler', 'Nummerplade', carString)
                            }
                        }
                    }
                    let vehicleResult = this.vehicleData.general.MaerkeTypeNavn + ' ' + this.vehicleData.general.ModelTypeNavn + ' ' + this.vehicleData.general.VariantTypeNavn
                    axios.post('https://hooks.slack.com/services/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', {
                        username: 'NrPladeTjek.dk',
                        icon_url: 'https://nrpladetjek.dk/static/apple-icon.png',
                        text: '*' + this.vehicleData.general.RegNr + '*\n' + vehicleResult + '\n----------'
                        },
                        {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        }
                    })
                }
            }, (err) => {
                alert('Vi kunne ikke finde nummerpladen. Tjek venligst det indtastede og prøv igen.')
                console.log(err)
                this.loading = false
                if (process.env.NODE_ENV === 'production') {
                    if ('ga' in window) {
                        let tracker = window.ga.getAll()[0]
                        if (tracker) {
                            tracker.send('event', 'Søgninger uden resultat', 'Nummerplade', this.licenseplate)
                        }
                    }
                }
            })
        },
        checkForQuery () {
            let query = this.$route.params.licenseplate
            if (query) {
                this.licenseplate = query
                this.doSearch()
            }
        },
        showInspectionReport (report) {
            this.showInspectionReportModal = true
            this.inspectionReport = report
        },
        closeInspectionReport () {
            this.inspectionReport = null
        }
    },
    computed: {
        monthlyExpense () {
            let consumption = (this.calculator.kmPerYear / this.vehicleData.general.MotorKmPerLiter) * 11
            let serviceAndRepairs = (this.calculator.kmPerYear / 100) * this.calculator.expensePerHundredKm
            let payoff = this.calculator.payoff * 12
            let insurance = this.calculator.insurance
            return Number((consumption + serviceAndRepairs + payoff + insurance) / 12).toFixed(0)
        }
    }
}
</script>



// WEBPACK FOOTER //
// index.vue?33c057f2